import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { OptimizelyProvider as Provider, createInstance } from '@optimizely/react-sdk'
import { ContentLoader } from '../components/ContentLoader'

const optimizely = createInstance({
  sdkKey: process.env.REACT_APP_OPTIMIZELY_SDK_KEY,
})

const getSnowplowDomainUserId = () => (
  new Promise((resolve, reject) => {
    // Note: must use `function()` instead of an arrow function syntax because
    // the API returns the tracker holder in `this`.
    window.snowplow(function callback() {
      // Corresponds to 'cf' defined in the Snowplow tag in GTM.
      const tracker = this.cf

      if (!tracker) {
        reject(new Error('No snowplow tracker'))
      }

      const domainUserId = tracker.getDomainUserId()

      resolve(domainUserId)
    })
  })
)

const OptimizelyProvider = ({ children, userId }) => {
  const [userIdForOptimizely, setUserIdForOptimizely] = useState(userId)
  const [hasSnowplow, setHasSnowplow] = useState(false)

  const waitForSnowplow = () => {
    if (window.snowplow) {
      setHasSnowplow(true)
    } else {
      setTimeout(waitForSnowplow, 250)
    }
  }

  if (!hasSnowplow) {
    waitForSnowplow()
  }

  useEffect(() => {
    if (!userId && hasSnowplow) {
      const setSnowplowIdForOptimizely = async () => {
        const idForOptimizely = await getSnowplowDomainUserId()
        setUserIdForOptimizely(idForOptimizely)
      }

      setSnowplowIdForOptimizely()
    }
  }, [userId, hasSnowplow])

  return (userIdForOptimizely
    ? (
      <Provider
        optimizely={optimizely}
        user={{ id: userIdForOptimizely }}
        timeout={500}
      >
        {children}
      </Provider>
    ) : <ContentLoader />)
}

OptimizelyProvider.propTypes = {
  children: PropTypes.node.isRequired,
  userId: PropTypes.string,
}

OptimizelyProvider.defaultProps = {
  userId: null,
}

export { OptimizelyProvider, getSnowplowDomainUserId }
